import {HostListener, Injectable, Injector, inject} from '@angular/core';
import {MatStepper} from "@angular/material/stepper";
import {SharedDataService} from "../modules/shared/shared.data.service";
import { JsonService } from './core/json.service';
import { PdfLinkService } from './pdf-link.service';
// import {NgControl} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  public expansionStep: number = -1;
  // Looked up on first use (not injected eagerly) so this widely-used service doesn't need HttpClient to be constructed.
  private readonly injector = inject(Injector);
  constructor(
    public sharedDataService: SharedDataService,
    public jsonService: JsonService
  ) {}


  onInputChange(event: any, backspace: boolean) {
    let newVal = event.replace(/[^0-9.]/g, '');
    const valueParts = newVal.split(".");
    newVal = valueParts[0];

    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1);
    }

    if (newVal.length === 0) {
      newVal = "";
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, "$1");
    } else if (newVal.length <= 4) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})/, "$1,$2");
    } else if (newVal.length <= 5) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})/, "$1,$2");
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "$1,$2");
    } else if (newVal.length <= 7) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})(\d{0,4})/, "$1,$2,$3");
    } else if (newVal.length <= 8) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})/, "$1,$2,$3");
    } else if (newVal.length <= 9) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, "$1,$2,$3");
    } else {
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(
        /^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/,
        "$1,$2,$3,$4"
      );
    }
    if (valueParts[1] != undefined){
      newVal = newVal + '.' + valueParts[1];
    }
    // this.ngControl?.valueAccessor?.writeValue(newVal);
    return newVal;
  }
  formatCurrencyToNumber(value: any){
    if (isNaN(value)){
      return value ? parseFloat(value.replace(/,/g, '')) : 0;
    }
    return parseFloat(value);
  }

   sanitizeNumber(value: any){
    return value ? value : 0;
   }
   formatToCurrency(value: number, decimalPlaces: number =2, currencySign: string = '$'): string {
    // Convert the number to a string with specified decimal places
    let formattedValue = value.toFixed(decimalPlaces);

    // Add the currency sign before the formatted number
    return `${currencySign}${formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }



  onFocusOut(value: any){
    let newVal = value.replace(/,/g, '');
    newVal = parseFloat(newVal);
    newVal = newVal.toFixed(2);
    this.onInputChange(newVal,  false);
  }
  toNumber(val: any) {
    let valArr = val.split("");
    let valFiltered = valArr.filter((x: any) => !isNaN(x));
    let valProcessed = valFiltered.join("");
    return valProcessed;
  }
  removeHttp(url: any){
    url = url.replace(/^https?:\/\//, '');
    url = url.replace(/^http?:\/\//, '');
    return url;
  }

   Integernumber(event: Event) {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    val = val.replace(/^0+|[^\d.]/g, '');
    if ((event instanceof KeyboardEvent) && (event as KeyboardEvent).key === '-' && val.length > 0) {
      event.preventDefault();
      return;
    }
    input.value = val;
  }

  validateMaxValue(event: Event,maxValue: any) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // If the value is greater than 12, set the value to 12
    if (parseInt(currentValue, 10) > maxValue) {
      inputElement.value = maxValue;
    }
  }
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
  targetBlank(url: any) {
    window.open(url,'_blank');
  }
  stepperGoBack(stepper: MatStepper) {
    stepper.previous();
  }
  //TAbS Expansion methods
  toggleMatExpansion(index: number){
    this.expansionStep = this.expansionStep == index ? -1 : index;
  }
  isMatExpansionOpen(index: number){
    return this.expansionStep === index
  }
  // END TAbS Expansion methods


  checkLoadMoreOptionVisibility(isIncrement: boolean,proposalInfoList:any,meta:any,param:any) {
    let showLoadMoreOption:boolean=false
    if (proposalInfoList.length > 0) {
      if (param.per_page <= meta?.total) {
        isIncrement ? (param.per_page += 10) : param.per_page;
        showLoadMoreOption = true;
      } else {
        showLoadMoreOption = false;
      }
    }else{
      showLoadMoreOption = false;
    }
    return showLoadMoreOption
  }

  // New function added for the Load More Options
  shouldLoadMore(List:any,meta:any){
    return List.length < meta?.total ? true : false
  }
  
  checkActivityLogLoadMoreOptionVisibility(activityList:any,meta:any) {
    return activityList.length < meta?.total ? true : false
    
    // let showLoadMoreOption: boolean = false;
    // if (activityList.length < meta?.total) {
    //   showLoadMoreOption = true;
    // }else{
    //   showLoadMoreOption = false;
    // }
    // return showLoadMoreOption
  }

   getCommaSeparatedString(arr: any[], key: string,separator: string = ','): string {
    // Check if the array is null, undefined, or empty, or if the key is invalid
    if (!Array.isArray(arr) || arr.length === 0 ) {
      return '';
    }
   let validItems:any = [];
    if(key){
      // Filter out any items where the key doesn't exist or is undefined/null
       validItems = arr.filter(item => item[key] !== undefined && item[key] !== null);
    }else{
       validItems = arr.filter(item => item !== undefined && item !== null);
    }

    // If there are no valid items, return an empty string
    if (validItems.length === 0) {
      return '';
    }

    // Map the valid items to their respective key values and join them into a comma-separated string
    return validItems.map((item:any) => key?  item[key]: item).join(separator);
  }

  /**
   * Shared "Download File"/Preview URL builder — used by every module's detail
   * component after the Export PDF dialog closes (Bid, Job, Submittal, Change
   * Order, Customer, Staff, Product, Vendor, Warehouse, Service, Subcontractor,
   * Jobsite, Task, Ticket, Note; only Proposal has its own override).
   *
   * "Download File" merge: selecting more than one template and clicking
   * Download (type 1) now merges them into a single PDF — same fix Proposal's
   * own detail-proposal.component.ts:getTemplates() already does, centralized
   * here once so every caller above gets it for free. One repeated-param URL
   * (`template_id[]=`) hits the SAME existing generate-pdf endpoint, which
   * merges server-side (PDFController::mergeModuleTemplates()/
   * mergeCommonPdfTemplates()) — no new endpoint. Preview (type 2) and a
   * single-template download both keep the original one-tab-per-template
   * behavior below, unchanged.
   */
  getTemplates(apiUrl:any, module_id:any,data: any) {
    const userDetail = this.jsonService.doParse(localStorage.getItem("auth_detail"))
    const templateIds: any[] = Object.values(data?.templates ?? {});
    const orderedItems: any[] = Object.values(data?.orderedItems ?? {});

    // Ordered template+document merge (Phase 1 — Job only so far; see
    // ExportPdfSharedComponent.downloadPdf()'s documentMergeSupported()
    // gate, which is the only place `orderedItems` ever gets populated).
    // Preserves the user's exact Templates-bar selection order, which a
    // plain template_id[] merge below can't — see
    // PdfVivliostyleService::generateOrderedMergedPdf()'s docblock.
    if (data?.type === 1 && orderedItems.length > 1) {
      const itemParams = orderedItems.map((token: any) => `items[]=${encodeURIComponent(token)}`).join('&');
      const url = `${apiUrl}?id=${module_id}&${itemParams}&output=1&user_id=${userDetail?.id}`;
      this.injector.get(PdfLinkService).openSigned(url);
      return;
    }

    if (data?.type === 1 && templateIds.length > 1) {
      const templateParams = templateIds.map((templateValue: any) => `template_id[]=${templateValue}`).join('&');
      const url = `${apiUrl}?id=${module_id}&${templateParams}&output=1&user_id=${userDetail?.id}`;
      this.injector.get(PdfLinkService).openSigned(url);
      return;
    }

    templateIds.map((templateValue:any,) => {
      const url = `${apiUrl}?id=${module_id}&template_id=${templateValue}&output=${data?.type}&user_id=${userDetail?.id}`
      this.injector.get(PdfLinkService).openSigned(url);
    })
  }


  // todo I will remove this after implement getColumnConfiguration in all listing tables.
  getColumnVisibility(columnName: string, module: string, defaultValue: boolean = false): boolean {
    const savedColumnSettings = localStorage.getItem(module);

    if (savedColumnSettings) {
      let columnSettings = JSON.parse(savedColumnSettings);
      if (!columnSettings || !columnSettings.columns) {
        return defaultValue; // Default to false if no settings are found
      }

      const column = columnSettings.columns.find(
        (col: any) => col.dataField === columnName || col.name === columnName
      );
      return column ? column.visible : defaultValue;

    }

    return defaultValue;
  }

  // Convert Object to Array
  convertObjectToArray(obj: any): any[] {
    // Convert object values to an array
    return Object.values(obj);
  }

  // ── Permission lookup ────────────────────────────────────────────────────
  //
  // isPermissionAvailable is called from ~29 template bindings on a single
  // detail route, so it runs on every change detection pass — every hover,
  // click, keystroke and HTTP response.
  //
  // It used to rebuild TWO fully normalized copies of the whole permission list
  // on every call. With 1,296 permissions that is 1296 x 3 regexes x 2 = 7,776
  // regex operations per call, ~1.1 ms each, ~33 ms per change detection pass —
  // 95% of the pass. Hovering a button queued enough passes to delay its tooltip
  // by well over a second.
  //
  // The normalized sets are now built once and reused until the permission list
  // itself changes. SharedDataService.getPermissions() returns
  // PermissionService.snapshot(), i.e. the BehaviorSubject's current value, so a
  // reference comparison is an exact and O(1) invalidation check: the reference
  // changes precisely when apply()/clear() pushes a new array.

  /** The permission array the cached sets were built from (reference identity). */
  private permissionCacheSource: string[] | null = null;
  private normalizedPermissionsStrict = new Set<string>();
  private normalizedPermissionsLoose = new Set<string>();

  /** Memoised normalisation of the (constant) permission names call sites ask for. */
  private readonly requiredPermissionCache = new Map<string, { strict: string; loose: string }>();

  private static normalizeStrict(value: string): string {
    return (value || '')
      .trim()
      .toUpperCase()
      .replace(/[_\s]+/g, '-')
      .replace(/-+/g, '-');
  }

  private static normalizeLoose(value: string): string {
    return HelperService.normalizeStrict(value).replace(/[^A-Z0-9]/g, '');
  }

  private ensurePermissionCache(): void {
    const source = this.sharedDataService.getPermissions() || [];
    if (source === this.permissionCacheSource) {
      return;
    }

    const strict = new Set<string>();
    const loose = new Set<string>();
    for (const permission of source) {
      const trimmed = (permission || '').trim();
      if (!trimmed) {
        continue;
      }
      strict.add(HelperService.normalizeStrict(trimmed));
      loose.add(HelperService.normalizeLoose(trimmed));
    }

    this.normalizedPermissionsStrict = strict;
    this.normalizedPermissionsLoose = loose;
    this.permissionCacheSource = source;
  }

  private normalizeRequired(requiredPermission: string): { strict: string; loose: string } {
    let entry = this.requiredPermissionCache.get(requiredPermission);
    if (!entry) {
      entry = {
        strict: HelperService.normalizeStrict(requiredPermission),
        loose: HelperService.normalizeLoose(requiredPermission),
      };
      this.requiredPermissionCache.set(requiredPermission, entry);
    }
    return entry;
  }

  isPermissionAvailable(requiredPermission: string){

    if (requiredPermission !== 'DONOTAPPLY') {
      const isSuperAdmin = this.sharedDataService.getIsCurrentUserSuperAdmin()

      if (!isSuperAdmin){
        this.ensurePermissionCache();
        const required = this.normalizeRequired(requiredPermission);
        if (
          this.normalizedPermissionsStrict.has(required.strict) ||
          this.normalizedPermissionsLoose.has(required.loose)
        ) {
          return  true;
        } else {
          return  false;
        }
      }

      if(requiredPermission == 'disable'){
        return false;
      }

    }
    return true
  }


  pluck(arr: any[], key: string): any[] {
    // Check if the first parameter is an array and contains objects
    if (!Array.isArray(arr) || !arr.every(item => typeof item === 'object')) {
      return [];
    }

    // Return an array of values corresponding to the specified key
    return arr.map(item => item[key]).filter(value => value !== undefined && value !== null);
  }
}
